export default "__VITE_ASSET__635b8778__"